<template>
    <v-card class="mx-5">
        <v-card-title class="px-5 pt-5 pb-4">
            <v-icon class="mr-3">mdi-account-convert</v-icon>
            <span class="heebo fw600">Leihspieler</span>
            <v-spacer></v-spacer>
            <v-select :items="sportJahre" outlined  label="Sportjahr" dense hide-details
                        class="pr-5" style="max-width: 160px" v-model="sportJahr">
            </v-select>
            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder
                          label="Suchen" filled single-line hide-details dense style="max-width: 250px">
                <template v-slot:append>
                    <v-btn icon small class="pb-1">
                        <v-icon style="cursor: pointer" @click="search=''">mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="itemsTable" :search="search"
                      class="elevation-1" :items-per-page="15">
            <template v-slot:item.actions="{ item }">
                <div class="text-no-wrap">
                    <v-btn small color="primary" class="mr-3" @click="editItem(item)">
                        <v-icon small class="mr-1">mdi-pencil</v-icon>Leihpass
                    </v-btn>
                    <paesse-leihe-delete :spieler="item" class="d-inline-block" :sport-jahr="sportJahr"></paesse-leihe-delete>
                </div>
            </template>
            <template v-slot:no-data>
                Momentan sind für dieses Sportjahr noch keine Spieler verliehen!
            </template>
        </v-data-table>
        <paesse-leihe-edit :itemSelected="itemSelected"></paesse-leihe-edit>
    </v-card>
</template>

<script>
    import {Spieler} from "../../services/data/spieler/spieler";
    import SPIELER_CHANGE_HANDLER from "../../services/data/spieler/spielerChangeHandler";
    import SPIELER_MEMBERSHIP_HANDLER from "../../services/data/spieler/spielerMembershipHandler";
    import TimeStamp from "../../services/timeStamp";
    import PaesseLeiheEdit from "./paesseLeiheEdit";
    import PaesseLeiheDelete from "./paesseLeiheDelete";

    export default {
        components: {
            PaesseLeiheDelete,
            PaesseLeiheEdit},
        name: "paesse-leihe",
        data: () => ({
            search: null,
            sportJahr: null,
            headers: [],
            itemsTable: [],
            itemSelected: null,
        }),
        computed: {
            sportJahre(){
                return [{value: this.$store.state.local.sportJahr.current.value,
                        text: this.$store.state.local.sportJahr.current.text},
                        {value: this.$store.state.local.sportJahr.previous.value,
                         text: this.$store.state.local.sportJahr.previous.text}]
            },
            leihSpieler(){ return this.$store.state.realtime.pendingLeihspieler}
        },
        created(){
            this.setCurrentSportJahr();
            this.initialize();
        },
        methods: {
            initialize () {
                this.newItem = new Spieler();
                this.headers = this.newItem.getTableHeaders('leihspieler');
                this.headers.push({ text: 'Aktionen', value: 'actions', sortable: false });
                this.setTableItems();
                //this.headers.push({ text: 'Aktionen', value: 'actions', sortable: false })
            },
            setCurrentSportJahr(){
                this.sportJahr = this.$store.state.local.sportJahr.current.value;
            },
            setTableItems(){
                this.itemsTable = [];
                setTimeout(()=>{
                    let itemsTemp = [];
                    itemsTemp = this.setItems('leihSpieler', itemsTemp);
                    //if ( !this.searchInactive ) { itemsTemp = this.setItems('itemsExpired', itemsTemp) }
                    this.itemsTable = itemsTemp.sort((b, a) => a.local.leihPassNr > b.local.leihPassNr ? 1 : -1);
                }, 50);
            },
            setItems(itemType, itemsTemp){
                const today = TimeStamp.getTodayString();
                this[itemType].forEach( (item) => {
                    const membership = SPIELER_MEMBERSHIP_HANDLER.getMembershipForTodayOrFuture(item.memberships);
                // build verein
                    const verein = {id: membership.lvVereinId.substr(2)};
                    const lvId = membership.lvVereinId.substr(0, 2);
                    item.local = {vereinId: lvId + verein.id + ' - ' +
                            this.$store.state.realtime.landesverbaende[lvId].vereine[verein.id].name};
                // get regular passNr
                    if ( item.status === 'aktiv') {
                        item.passNr = SPIELER_CHANGE_HANDLER.getPassNumberForSportJahrValue(item); // , this.sportJahr, false
                    } else {
                        item.passNr = SPIELER_MEMBERSHIP_HANDLER.getLastRegularPassNr(item.memberships);
                    }
                // item status (including leihe
                    item.local.statusDisplay = item.search.lastAktiv &&
                                                item.search.lastAktiv[membership.lvVereinId] < today ?
                                                'abgelaufen' : SPIELER_MEMBERSHIP_HANDLER.overwriteWithLeiheSearch(item,
                                                    today);
                // leihpassnr
                    item.local.leihPassNr = SPIELER_MEMBERSHIP_HANDLER.getLeiheForSportJahr(item.memberships, this.sportJahr)?.passNr;
                // push
                    itemsTemp.push(item);
                });
                return itemsTemp;
            },
            editItem (item){
                this.itemSelected = JSON.parse(JSON.stringify(item));
                this.itemSelected.id = item.id;
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'leiheEdit';
                this.$router.push({path: p, query: q});
            },
        },
        watch: {
            sportJahr(){
                this.$emit('loadLeihSpielerList', this.sportJahr);
            },
            leihSpieler(){
                console.log ("WATCH ITEMS");
                this.setTableItems();
            },
        }
    }
</script>

<style scoped>

</style>